define('Coverage.View', [
	'coverage_pdp.tpl',
	'Backbone'
], function CoverageView(
	acs_pd_main_tpl,
	Backbone
) {
    'use strict';

	return Backbone.View.extend({

		template: acs_pd_main_tpl,

		initialize: function initialize(options) {
			this.termsLink = options.container.getComponent('Environment').getConfig("PDPExtra.coverage");
			this.plpComponent = options.container.getComponent('PLP');
			this.pdpComponent = options.container.getComponent('PDP');
		},

		getContext: function getContext() {
			var pdpItem = this.pdpComponent.getItemInfo();
			var plpItems = this.plpComponent.getItemsInfo();
			var plpCategory;
			var showCoverageLink = false;

			if (pdpItem && pdpItem.item) {
				showCoverageLink = true;
			} else if (plpItems && plpItems.length) {
				plpCategory = this.plpComponent.getCategoryInfo();
				showCoverageLink = plpCategory && plpCategory.name && plpCategory.name === 'AT&T';
			}

			return {
				showCoverageLink: showCoverageLink,
				link: this.termsLink
			};
		}
	});
});
